import React from 'react';

class LogoutUser extends React.Component{

    constructor(props){
        super(props);
        this.state={

        }
    }

    componentDidMount(){
        localStorage.removeItem("idToken");
        localStorage.removeItem("accessToken");
        this.props.history.push("/");
    }

    render(){
        return null;
    }
}

export default LogoutUser;


// WEBPACK FOOTER //
// ./src/Logout.jsx